if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          if (this.productElement.querySelector('media-gallery')) this.productElement.querySelector('media-gallery').dataset.disablePrepend = 'false';
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          this.setupGalleryThumbnails();

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const stickyAtc = this.productElement.querySelector('sticky-atc');
      if (stickyAtc) stickyAtc.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }

    setupGalleryThumbnails() {
      const gallery = this.modalContent.querySelector('media-gallery');
      if (!gallery || gallery.querySelector('.quick-add-gallery-thumbnails')) return;

      const mediaImages = Array.from(gallery.querySelectorAll('.product__media-item:not(.hidden) .product__media img')).slice(0, 3);
      if (mediaImages.length < 2) return;

      const primaryImage = mediaImages[0];
      const mediaContainer = primaryImage.closest('.product__media') || primaryImage.parentElement;
      const thumbnails = document.createElement('div');
      const controls = document.createElement('div');
      const previousButton = document.createElement('button');
      const nextButton = document.createElement('button');
      let activeIndex = 0;

      thumbnails.className = 'quick-add-gallery-thumbnails';
      thumbnails.setAttribute('role', 'list');
      controls.className = 'quick-add-gallery-controls';

      previousButton.type = 'button';
      previousButton.className = 'quick-add-gallery-nav quick-add-gallery-nav--previous';
      previousButton.setAttribute('aria-label', 'Show previous product image');
      previousButton.innerHTML = '<span aria-hidden="true">&lsaquo;</span>';

      nextButton.type = 'button';
      nextButton.className = 'quick-add-gallery-nav quick-add-gallery-nav--next';
      nextButton.setAttribute('aria-label', 'Show next product image');
      nextButton.innerHTML = '<span aria-hidden="true">&rsaquo;</span>';

      const setActiveMedia = (index) => {
        activeIndex = (index + mediaImages.length) % mediaImages.length;
        const image = mediaImages[activeIndex];
        const nextSrc = image.getAttribute('src');
        const nextSrcset = image.getAttribute('srcset');
        const nextSizes = image.getAttribute('sizes');

        if (nextSrc) primaryImage.setAttribute('src', nextSrc);
        if (nextSrcset) primaryImage.setAttribute('srcset', nextSrcset);
        if (nextSizes) primaryImage.setAttribute('sizes', nextSizes);
        primaryImage.setAttribute('alt', image.getAttribute('alt') || '');

        thumbnails.querySelectorAll('.quick-add-gallery-thumbnail').forEach((item, itemIndex) => {
          const isActive = itemIndex === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      previousButton.addEventListener('click', () => setActiveMedia(activeIndex - 1));
      nextButton.addEventListener('click', () => setActiveMedia(activeIndex + 1));
      controls.append(previousButton, nextButton);

      if (mediaContainer) {
        mediaContainer.classList.add('quick-add-gallery-media');
        mediaContainer.appendChild(controls);
      }

      mediaImages.forEach((image, index) => {
        const button = document.createElement('button');
        const thumbnail = image.cloneNode(false);

        button.type = 'button';
        button.className = `quick-add-gallery-thumbnail${index === 0 ? ' is-active' : ''}`;
        button.setAttribute('role', 'listitem');
        button.setAttribute('aria-label', image.alt ? `Show ${image.alt}` : `Show product image ${index + 1}`);
        button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');

        thumbnail.removeAttribute('id');
        thumbnail.removeAttribute('srcset');
        thumbnail.setAttribute('loading', 'lazy');
        thumbnail.setAttribute('sizes', '72px');

        button.appendChild(thumbnail);
        button.addEventListener('click', () => setActiveMedia(index));

        thumbnails.appendChild(button);
      });

      const viewer = gallery.querySelector('[id^="GalleryViewer"]') || gallery;
      viewer.insertAdjacentElement('afterend', thumbnails);
    }
  });
}
